export const EFA_TO_FARE_API_BASE_URL = 'EFA_TO_FARE_API_BASE_URL';
export const ON_DEMAND_PAYMENT_STATE_KEY = 'ON_DEMAND_PAYMENT_STATE';

export const AUSTRIAN_PHONE_PREFIX = '+43';
export const MILLISECONDS_PER_MINUTE = 60000;
export const MINUTES_PER_HOUR = 60;
export const MINIMUM_BOOKING_LOADING_DURATION_MS = 1000;
export const RESERVATION_DURATION_MINUTES = 15;
export const DEFAULT_TRANSFER_GRACE_MINUTES = 3; // buffer time for transfer
export const DEFAULT_ON_DEMAND_AVAILABILITY_LOOKBACK_MINUTES = 20; // time to extend availability options further back
export const TRANSFER_LEG_TYPE = 'TRSF';

export const ON_DEMAND_EXTRA_LABELS: Record<string, string> = {
  Bike: 'Fahrrad',
  Dog: 'Hund',
  Pram: 'Kinderwagen',
  WheelchairUser: 'Rollstuhl',
  MotorizedWheelchair: 'Elektrorollstuhl',
  FoldableWheelchair: 'Faltrollstuhl',
  WalkingFrame: 'Gehgestell',
  HeavyLuggage: 'Schweres Gepäck',
  NeedsChildSeat: 'Kindersitz (Fahrzeug)',
  NeedsBabyCarrier: 'Babyschale (Fahrzeug)',
  NeedsSeatBooster: 'Sitzerhöhung (Fahrzeug)',
  GuideDog: 'Blindenhund',
};

export const TRIAS_ON_DEMAND_ERROR_CODES = {
  BookingOk: 'BOOKING_OK',
  CancellationOk: 'CANCELLATION_OK',
  AvailabilityOk: 'AVAILABILITY_OK',
  AvailabilityDepartureTimeAdjusted: 'AVAILABILITY_DEPARTURETIMEADJUSTED',
  AvailabilityArrivalTimeAdjusted: 'AVAILABILITY_ARRIVALTIMEADJUSTED',
  AvailabilityDepartureLocationAdjusted:
    'AVAILABILITY_DEPARTURELOCATIONADJUSTED',
  AvailabilityArrivalLocationAdjusted: 'AVAILABILITY_ARRIVALLOCATIONADJUSTED',
  AvailabilityTooManyPersons: 'AVAILABILITY_TOOMANYPERSONS',
  AvailabilityOptionsNotSupported: 'AVAILABILITY_OPTIONSNOTSUPPORTED',
  AvailabilityJourneyUnknown: 'AVAILABILITY_JOURNEYUNKNOWN',
  AvailabilityJourneyNotAllowed: 'AVAILABILITY_JOURNEYNOTALLOWED',
  AvailabilityJourneyNotBookable: 'AVAILABILITY_JOURNEYNOTBOOKABLE',
};
